"use client"

import { ControlledModal } from "@/components"
import { graphql } from "@/gql"
import { useMutation } from "@apollo/client"
import { toast } from "@/components/Toast"
import { GetHirePageFilterCountsDocument } from "@/gql/graphql"

const DeleteJobPostingMutation = graphql(`
  mutation DeleteJobPosting($id: ID!) {
    deleteJobPosting(input: { id: $id }) {
      ok
    }
  }
`)

interface Props {
  jobId: string
  open: boolean
  onClose: () => void
  typename: "ClientJobPosting" | "CreativeJobPosting"
}

export const DeleteDraftJobPostingModal: React.FC<Props> = ({ jobId, open, onClose, typename }) => {
  const [deleteJobPosting, { loading }] = useMutation(DeleteJobPostingMutation)

  const handleDelete = () => {
    deleteJobPosting({
      variables: {
        id: jobId,
      },
      update(cache) {
        cache.evict({
          id: cache.identify({ id: jobId, __typename: typename }),
        })
        cache.gc()
      },
      refetchQueries: [GetHirePageFilterCountsDocument],
      awaitRefetchQueries: true,
      optimisticResponse() {
        return {
          deleteJobPosting: {
            ok: true,
          },
        }
      },
      onError() {
        toast.error("Failed to delete job posting")
      },
      onCompleted() {
        toast.success("Job posting deleted successfully")
        onClose()
      },
    })
  }

  return (
    <ControlledModal
      open={open}
      onOpenChange={onClose}
      header={{
        variant: "warning",
        title: "Delete Job Posting",
        subtitle: "Are you sure you want to delete this job posting\nThis action cannot be undone.",
        fixed: true,
      }}
      variant="warning"
      footer={{
        fixed: true,
        primaryButton: {
          children: "Delete",
          onClick: handleDelete,
          loading: loading,
          variant: "error",
        },
        tertiaryButton: {
          children: "Cancel",
          onClick: onClose,
        },
      }}
    />
  )
}
